/**
 * How long lesson records are kept.
 *
 * The bounds are the backend's, restated here so the form can refuse before the
 * round trip rather than after it. They are not a second opinion: the backend
 * rejects the same values, and this only decides what the person sees first.
 */
export const RETENTION_MIN_DAYS = 30;
export const RETENTION_MAX_DAYS = 730;

/**
 * Below this, a teacher loses last term's record before this term ends.
 *
 * A warning and not a limit. An institution with a strict deletion policy may
 * genuinely want 60 days, and telling them they may not is not our place; not
 * telling them what it costs would be.
 */
export const RETENTION_SHORT_WARNING_DAYS = 90;

export type RetentionVerdict = "ok" | "short" | "outOfRange";

export function retentionVerdict(days: number): RetentionVerdict {
  if (!Number.isInteger(days) || days < RETENTION_MIN_DAYS || days > RETENTION_MAX_DAYS) {
    return "outOfRange";
  }
  return days < RETENTION_SHORT_WARNING_DAYS ? "short" : "ok";
}
